const routeTo = (route: string) => {
    var popStateEvent = new PopStateEvent('popstate', { state: { route } });
    window.history.pushState({route}, '', `/${ route }`)
    dispatchEvent(popStateEvent);
}

export default routeTo